import { userConstants } from '../constants';
import { userService } from '../services';

export const userActions = {
  getHomeData,
  getPastConcerts,
  getConcerts,
  getConcert,
  getArtists,
  getNewsListing,
  getNews,
  getPressData,
  getAboutData,
  getFAQ,
  getUsefulContacts,
  getSponsors,
  getContactData,
  getDonationData,
  getPressFormData,
  getPressInnerData,
  getSearchResults,
  getSettingsData,
  getMetaData,
};

function getMetaData (page) {
  return (dispatch) => {
    dispatch(request());

    return userService.getMetaData(page).then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_META_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_META_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_META_DATA_ERROR, error };
  }
}

function getHomeData () {
  return (dispatch) => {
    dispatch(request());

    return userService.getHomeData().then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_HOME_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_HOME_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_HOME_DATA_ERROR, error };
  }
}

function getAboutData () {
  return (dispatch) => {
    dispatch(request());

    return userService.getAboutData().then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_ABOUT_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_ABOUT_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_ABOUT_DATA_ERROR, error };
  }
}

function getPressData () {
  return dispatch => {
    dispatch(request());

    return userService.getPressData().then(
      (res) => dispatch(success(res)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_PRESS_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_PRESS_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_PRESS_DATA_ERROR, error };
  }
}

function getPressInnerData (path) {
  return dispatch => {
    dispatch(request());

    return userService.getPressInnerData(path).then(
      (res) => dispatch(success(res)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_PRESS_INNER_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_PRESS_INNER_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_PRESS_INNER_DATA_ERROR, error };
  }
}

function getConcerts (status) {
  return (dispatch) => {
    dispatch(request());
    return userService.getConcerts(status).then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_CONCERTS_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_CONCERTS_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_CONCERTS_DATA_ERROR, error };
  }
}

function getPastConcerts (status) {
  return (dispatch) => {
    dispatch(request());
    return userService.getPastConcerts(status).then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_PAST_CONCERTS_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_PAST_CONCERTS_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_PAST_CONCERTS_DATA_ERROR, error };
  }
}

function getContactData () {
  return (dispatch) => {
    dispatch(request());

    return userService.getContactData().then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_CONTACTS_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_CONTACTS_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_CONTACTS_DATA_ERROR, error };
  }
}

function getConcert (url) {
  return (dispatch) => {
    dispatch(request());

    return userService.getConcert(url).then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_CONCERT_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_CONCERT_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_CONCERT_DATA_ERROR, error };
  }
}

function getArtists () {
  return (dispatch) => {
    dispatch(request());

    return userService.getArtists().then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_ARTISTS_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_ARTISTS_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_ARTISTS_DATA_ERROR, error };
  }
}

function getFAQ () {
  return (dispatch) => {
    dispatch(request());

    return userService.getFAQ().then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_FAQ_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_FAQ_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_FAQ_DATA_ERROR, error };
  }
}

function getUsefulContacts () {
  return (dispatch) => {
    dispatch(request());

    return userService.getUsefulContacts().then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_USEFULCONTACTS_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_USEFULCONTACTS_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_USEFULCONTACTS_DATA_ERROR, error };
  }
}

function getSettingsData () {
  return (dispatch) => {
    dispatch(request());

    return userService.getSettingsData().then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_SETTINGS_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_SETTINGS_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_SETTINGS_DATA_ERROR, error };
  }
}

function getSponsors () {
  return (dispatch) => {
    dispatch(request());

    return userService.getSponsors().then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_SPONSORS_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_SPONSORS_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_SPONSORS_DATA_ERROR, error };
  }
}

function getNewsListing (pageNum, limit) {
  return (dispatch) => {
    dispatch(request());

    return userService.getNewsListing(pageNum, limit).then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_NEWS_LISTING_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_NEWS_LISTING_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_NEWS_LISTING_DATA_ERROR, error };
  }
}

function getNews (url) {
  return (dispatch) => {
    dispatch(request());

    return userService.getNews(url).then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_NEWS_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_NEWS_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_NEWS_DATA_ERROR, error };
  }
}

function getDonationData () {
  return (dispatch) => {
    dispatch(request());

    return userService.getDonationData().then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_DONATION_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_DONATION_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_DONATION_DATA_ERROR, error };
  }
}

function getPressFormData () {
  return (dispatch) => {
    dispatch(request());

    return userService.getPressFormData().then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_PRESSFORM_DATA_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_PRESSFORM_DATA_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_PRESSFORM_DATA_ERROR, error };
  }
}

function getSearchResults (search) {
  return (dispatch) => {
    dispatch(request());

    return userService.getSearchResults(search).then(
      (res) => {
        return dispatch(success(res));
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request () {
    return { type: userConstants.GET_SEARCH_RESULTS_REQUEST };
  }

  function success (res) {
    return { type: userConstants.GET_SEARCH_RESULTS_SUCCESS, res };
  }

  function failure (error) {
    return { type: userConstants.GET_SEARCH_RESULTS_ERROR, error };
  }
}
